export default __webpack_public_path__ + "static/media/nrutyam.1289e110.jpeg";